import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {  getActiveSession } from "../../services/ActivePrograms";
import ViewSessionDetails from "./ViewSessionDetails";


const ViewSession = ({state,onclick,target,toggle,content,setNavbar,getSessionById}) => {
  // const location = useLocation();
  // const state = location.state;
  const [notes,setNotes] = useState({})
  const getSessionNotes = async() => {
      try {
        const response = await getActiveSession(state.programId)
        console.log(response.data.data.filter((session)=>session._id === state._id)[0])
        setNotes(response.data.data.filter((session)=>session._id === state._id)[0])
      } catch (error) {
        console.log(error)
      }
}
console.log(notes)

  //   const programID = state?.program?._id;
  //   const defaultProgram = [state?.program];
  //   const defaultIsFromCreate = state.isFromCreate; // To Navigate for Active program tab module

  //   const [program, setProgram] = useState(defaultProgram);
  //   const [isFromCreate, setIsFromCreate] = useState(defaultIsFromCreate);

  //   const getProgram = async () => {
  //     try {
  //       const response = await getActiveProgramById(programID);
  //       console.log(response, "active program details")
  //       if (response.status === 200) {
  //         setProgram(response?.data?.data);
  //       }
  //     } catch (error) {
  //       console.log(error)
  //     }
  //   }

  return (
    <>

          <div className="col-md-12">
            {/* <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li
                  class="breadcrumb-item cursor-pointer"
                  onClick={() => navigate(-1)}
                >
                  Session
                </li>
                <li class="breadcrumb-item active fw-bold" aria-current="page">
                  View Session Details
                </li>
              </ol>
            </nav> */}
            {/* <h3>View Session Details </h3>
            <p className="resFont">Individual Video Session</p> */}

              <ViewSessionDetails getSessionById={getSessionById} getSessionNotes={getSessionNotes}  state={state} notes={notes} setNavbar={setNavbar} onclick={onclick} toggle={toggle} target={target} content={content}/>
          </div>

    </>
  );
};

export default ViewSession;
